// DGML's embeddings are L2-normalised, so the dot product already is the cosine;
// dividing by the norms anyway keeps the number honest if that ever changes.
export function cosineSimilarity(a: number[], b: number[]): number {
  if (a.length !== b.length || a.length === 0) {
    return NaN;
  }

  let dot = 0;
  let normA = 0;
  let normB = 0;

  for (let i = 0; i < a.length; i++) {
    dot += a[i] * b[i];
    normA += a[i] * a[i];
    normB += b[i] * b[i];
  }

  if (normA === 0 || normB === 0) {
    return NaN;
  }

  return dot / (Math.sqrt(normA) * Math.sqrt(normB));
}

export function l2Norm(vector: number[]): number {
  return Math.sqrt(vector.reduce((sum, value) => sum + value * value, 0));
}
